import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          综艺专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按类别浏览，快速找到你想看的热门综艺
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 rounded-xl p-5 flex items-start gap-4 hover:bg-background-200/50 transition-all cursor-pointer"
            >
              <span className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}